export default __webpack_public_path__ + "static/media/back1.661c458e.svg";